import React, { useEffect, useState } from "react";
import styles from "./CartSidebar.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useCart } from "../../context/CartContext";
import CartEnquiryModal from "../CartEnquiryModal";

interface CartItem {
  id: string;
  name: string;
  price: number;
  image: string;
  quantity: number;
}

interface CartSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  cart: CartItem[];
  onUpdateQuantity: (id: string, quantity: number) => void;
}

const CartSidebar: React.FC<CartSidebarProps> = ({
  isOpen,
  onClose,
  cart,

  onUpdateQuantity,
}) => {
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const [showEnquiryCartModel, setShowEnquiryModal] = useState(false);

  // Lock body scroll when cart is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);
  const { removeFromCart } = useCart();
  return (
    <>
      {showEnquiryCartModel === false ? (
        <>
          <div
            className={`${styles.overlay} ${isOpen ? styles.active : ""}`}
            onClick={onClose}
          />
          <aside className={`${styles.sidebar} ${isOpen ? styles.active : ""}`}>
            <div className={styles.header}>
              <h2>Your Cart</h2>
              <button className={styles.closeBtn} onClick={onClose}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className={styles.items}>
              {cart.length === 0 ? (
                <p className={styles.empty}>Your cart is empty</p>
              ) : (
                cart.map((item) => (
                  <div key={item.id} className={styles.item}>
                    <img
                      // @ts-ignore
                      src={item.picture?.[0]?.path}
                      alt={item.name}
                      className={styles?.image}
                    />
                    <div className={styles.details}>
                      <h4>{item.name}</h4>
                      <p>₹{item.price}</p>
                      <div className={styles.quantity}>
                        <button
                          onClick={() =>
                            onUpdateQuantity(item.id, item.quantity - 1)
                          }
                          disabled={item.quantity <= 1}
                        >
                          -
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          onClick={() =>
                            onUpdateQuantity(item.id, item.quantity + 1)
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <button
                      className={styles.remove}
                      // @ts-ignore
                      onClick={() => removeFromCart(item._id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                ))
              )}
            </div>

            {cart.length > 0 && (
              <div className={styles.footer}>
                <div className={styles.total}>
                  <span>Total:</span>
                  <strong>₹{total}</strong>
                </div>
                <button
                  className={styles.checkout}
                  onClick={() => setShowEnquiryModal(true)}
                >
                  Enquire Now
                </button>
              </div>
            )}
          </aside>
        </>
      ) : (
        <CartEnquiryModal
          show={showEnquiryCartModel}
          onHide={() => {
            onClose();
            setShowEnquiryModal(false);
          }}
        />
      )}
    </>
  );
};

export default CartSidebar;
